import { useErpSourceList } from 'context/Store';
import { useIngredientList } from 'context/Store';

export default function useData() {
	const erpSourceList = useErpSourceList();
	const ingredientList = useIngredientList();

	return {
		erpSources: erpSourceList,
		ingredients: ingredientList,
	};
}

export type RecipeErpViewData = ReturnType<typeof useData>;
